import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import queryString from "query-string";
import {themeRegister} from "../../services/themeRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {flowRegister} from "../../services/flowRegister";
import {cartRegister} from "../../services/cartRegister";
import {userRegister} from "../../services/userRegister";
import {agentRegister} from "../../services/agentRegister";
import {collectedRegister} from "../../services/collectedRegister";

class SignupAdsFacebookCanvas extends Component {

    constructor(props) {
        super(props);
        this.state = {
            website: null,
            industry: null,
            main_image: null,
            one_image: null,
            two_image: null,
            three_image: null
        };
    };

    componentDidMount() {
        this._updateData();
        this.init.data();
        this.init.images();
    }

    init = {
        data: () => {

            if (collectedRegister.getValue("custom_creative")) {

                let data_custom_creative = {};

                let data = themeRegister.getValue();
                let theme = themeRegister.getTheme();

                let theme_data = themeRegister.getValue();
                if(theme_data && theme_data.theme_region){
                    if (langRegister.lang() === "sv") {
                        data_custom_creative.agent_description = "Expert på " + theme_data.theme_region;
                    } else {
                        data_custom_creative.agent_description = theme_data.theme_region + " Expert";
                    }
                }

                let user_data = userRegister.getUser();
                let agent_data = agentRegister.get();
                if(user_data && user_data.branding_pref){
                    data_custom_creative.branding_image = user_data.branding_image;
                }

                try {

                    data_custom_creative.type = JSON.parse(collectedRegister.getValue("type")).title;
                    //TODO: type_default only tested in EN and SE lang, other langs need to be tested
                    data_custom_creative.type_default = JSON.parse(collectedRegister.getValue("type")).title + " " + collectedRegister.getValue("offering");
                    data_custom_creative.offering = collectedRegister.getValue("offering");

                    if (theme === "promotion") {
                        data_custom_creative.slogan = theme_data.slogan_offer;
                    } else {
                        data_custom_creative.slogan = theme_data.slogan_validation;
                    }

                    if (collectedRegister.getValue("listing_type").indentifier === "sale") {
                        data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("status")).title;
                    } else {
                        data_custom_creative.slogan_offering = JSON.parse(collectedRegister.getValue("furnishings")).title;
                    }

                    data_custom_creative.slogan_promo = theme_data.slogan_offer;
                    data_custom_creative.slogan_calltoaction = theme_data.slogan_action;

                    data_custom_creative.area = theme_data.theme_region;
                    data_custom_creative.building = collectedRegister.getValue("google").autocomplete_address;
                    data_custom_creative.city = collectedRegister.getValue("display_region").name;

                    data_custom_creative.size = collectedRegister.getValue("size_custom");
                    data_custom_creative.beds = JSON.parse(collectedRegister.getValue("bed")).title;
                    data_custom_creative.baths = JSON.parse(collectedRegister.getValue("bath")).title;
                    data_custom_creative.price = theme_data.last_title;

                } catch (e) {}

                try {
                    if (collectedRegister.getValue("contact").permit) {
                        data_custom_creative.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                    }
                } catch (e) {}

                try {
                    if (collectedRegister.getValue("qrcode_ads")) {
                        data_custom_creative.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                    }
                } catch (e) {}

                if(agent_data && agent_data.profile_image){
                    if(agent_data && agent_data.profile_image){
                        data_custom_creative.agent_image = agent_data.profile_image;
                    }
                    if(agent_data && agent_data.name){
                        data_custom_creative.agent_name = agent_data.name;
                    }
                }else{
                    if(user_data && user_data.profile_image){
                        data_custom_creative.agent_image = user_data.profile_image;
                    }
                    if(user_data && user_data.logo_image){
                        data_custom_creative.agency_image = user_data.logo_image;
                    }
                    if(user_data && user_data.name){
                        data_custom_creative.agent_name = user_data.name;
                    }
                }

                let query = queryString.stringify(data_custom_creative);
                this.setState({
                    theme: theme,
                    query: query
                });

            } else {

                let data = themeRegister.getValue();
                let theme = themeRegister.getTheme();

                let theme_data = themeRegister.getValue();
                if(theme_data && theme_data.theme_region){
                    if (langRegister.lang() === "sv") {
                        data.agent_description = "Expert på " + theme_data.theme_region;
                    } else {
                        data.agent_description = theme_data.theme_region + " Expert";
                    }
                }

                let user_data = userRegister.getUser();
                let agent_data = agentRegister.get();
                console.log(user_data);
                console.log(agent_data);

                if(user_data && user_data.branding_pref){
                    if(user_data.branding_pref.primary_color){
                        data.primary_color = user_data.branding_pref.primary_color;
                    }
                    if(user_data.branding_pref.secondary_color){
                        data.secondary_color = user_data.branding_pref.secondary_color;
                    }
                    if(user_data.branding_image){
                        data.branding_image = user_data.branding_image;
                    }
                }

                try {
                    if(user_data && user_data.branding_pref){
                        data.disable_infobox = user_data.branding_pref.disable_infobox ? user_data.branding_pref.disable_infobox : false;
                        data.infobox_m = user_data.branding_pref.infobox_m ? user_data.branding_pref.infobox_m : false;
                        data.infobox_s = user_data.branding_pref.infobox_s ? user_data.branding_pref.infobox_s : false;
                        data.opacity_infobox = user_data.branding_pref.opacity_infobox ? user_data.branding_pref.opacity_infobox : false;
                    }
                } catch (e) {}

                if(user_data && user_data.logo_image){
                    data.agency_image = user_data.logo_image;
                }
                if(!data.agent_description && user_data.company_name){
                    data.agent_description = user_data.company_name;
                }
                if(!data.agent_description && user_data.billing_company){
                    data.agent_description = user_data.billing_company;
                }

                if(agent_data && agent_data.profile_image){
                    if(agent_data && agent_data.profile_image){
                        data.agent_image = agent_data.profile_image;
                    }
                    if(agent_data && agent_data.email){
                        try{
                            let split_email = agent_data.email.split("@");
                            if(Array.isArray(split_email) && split_email.length > 1){
                                data.agency_website = split_email[1];
                            }
                        }catch (e) {}
                    }
                    if(agent_data && agent_data.name){
                        data.agent_name = agent_data.name;
                    }
                    if (user_data.fallback_pref && user_data.fallback_pref.phone) {
                        data.agent_phone = user_data.phone;
                    } else {
                        if (agent_data && agent_data.phone) {
                            data.agent_phone = agent_data.phone;
                        }
                    }
                }else{
                    if(user_data && user_data.profile_image){
                        data.agent_image = user_data.profile_image;
                    }
                    if(user_data && user_data.logo_image){
                        data.agency_image = user_data.logo_image;
                    }
                    if(user_data && user_data.email){
                        try{
                            let split_email = user_data.email.split("@");
                            if(Array.isArray(split_email) && split_email.length > 1){
                                data.agency_website = split_email[1];
                            }
                        }catch (e) {}
                    }
                    if(user_data && user_data.name){
                        data.agent_name = user_data.name;
                    }
                    if(user_data && user_data.phone){
                        data.agent_phone = user_data.phone;
                    }
                }

                try {
                    if (collectedRegister.getValue("contact").permit) {
                        data.permit = collectedRegister.getValue("contact").permit ? collectedRegister.getValue("contact").permit : ""
                    }
                } catch (e) {}

                try {
                    if (collectedRegister.getValue("qrcode_ads")) {
                        data.qrcode = collectedRegister.getValue("contact").qrcode ? collectedRegister.getValue("contact").qrcode : ""
                    }
                } catch (e) {}

                let query = queryString.stringify(data);
                this.setState({
                    theme: theme,
                    query: query
                });
            }
        },
        images: () => {
            let images = imagesRegister.get();
            let cart = cartRegister.get();
            let slides = [];
            let main_image = null;
            let first_image = null;
            let second_image = null;
            let third_image = null;
            for (let i = 0; i < images.length; i++) {
                if (images[i].label && slides.length < 9) {
                    let slide = {
                        small: images[i].images.small,
                        large: images[i].images.large
                    };
                    slides.push(slide);
                }
            }
            if (cart.admin_image) {
                main_image = cart.admin_image.images.large;
            }
            if (slides[0]) {
                first_image = slides[0].small;
            }
            if (slides[1]) {
                second_image = slides[1].small;
            }
            if (slides[2]) {
                third_image = slides[2].small;
            }
            this.setState({
                main_image: main_image,
                one_image: first_image,
                two_image: second_image,
                three_image: third_image
            }, () => {
                //let url = "http://localhost:3001/";
                let url = "";
                if (collectedRegister.getValue("custom_creative")) {
                    url = "https://coral-app-xg6gr.ondigitalocean.app/";
                    this.props.onChange(url + collectedRegister.getValue("reseller_name") + "/canvas/" +
                        this.state.theme + "/first/1_1?" +
                        "main_image=" + this.state.main_image +
                        "&one_image=" + this.state.one_image +
                        "&two_image=" + this.state.two_image +
                        "&three_image=" + this.state.three_image +
                        "&" + this.state.query + "&legacy=false");
                } else {
                     url = "https://preview." + dataRegister.domain + "/";
                    this.props.onChange(url + salesChannelRegister.get("name") + "/canvas/" +
                        this.state.theme + "/first/facebook?" +
                        "main_image=" + this.state.main_image +
                        "&one_image=" + this.state.one_image +
                        "&two_image=" + this.state.two_image +
                        "&three_image=" + this.state.three_image +
                        "&" + this.state.query);
                }

            });
        }
    };

    _updateData() {
        this.setState({
            industry: this.props.industry,
            website: this.props.website,
        }, () => {
            console.log(this.state);
        });
    }

    _renderAdImage() {
        //let url = "http://localhost:3001/";
        let url = "https://preview." + dataRegister.domain + "/";
        if (collectedRegister.getValue("custom_creative")) {
            url = "https://coral-app-xg6gr.ondigitalocean.app/";
        }
        if (this.state.theme && this.state.main_image && this.state.query) {
            return (
                <div className={Styles.imagesContainerItem} style={collectedRegister.getValue("custom_creative")?{paddingTop: '100%'}:{}}>
                    <div className={Styles.imagesContainerItemInner}>
                        {
                            <iframe frameBorder={"none"}
                                    height={"100%"}
                                    width={"100%"}
                                    src={collectedRegister.getValue("custom_creative") ? url + collectedRegister.getValue("reseller_name")  + "/canvas/" +
                                    this.state.theme + "/first/1_1?" +
                                    "main_image=" + this.state.main_image +
                                    "&one_image=" + this.state.one_image +
                                    "&two_image=" + this.state.two_image +
                                    "&three_image=" + this.state.three_image +
                                    "&" + this.state.query + "&legacy=false"
                                    :
                                    url + salesChannelRegister.get("name") + "/canvas/" +
                                    this.state.theme + "/first/facebook?" +
                                    "main_image=" + this.state.main_image +
                                    "&one_image=" + this.state.one_image +
                                    "&two_image=" + this.state.two_image +
                                    "&three_image=" + this.state.three_image +
                                    "&" + this.state.query}
                                    allowFullScreen
                                    className={Styles.iframe}
                            />
                        }
                    </div>
                </div>
            )
        }
    }

    _renderText(item) {
        return langRegister.get("signup-ads", item);
    }

    render() {
        return (
            <div>
                {
                    this._renderAdImage()
                }
                {
                    !this.state.website &&
                    <div className={Styles.contentContainerLeftFacebookItemAdLink}>
                        {this._renderText("item_60")}
                    </div>
                }
                {
                    this.state.website &&
                    <div className={Styles.contentContainerLeftFacebookItemAdLink}>
                        {this.state.website}
                    </div>
                }
                <div className={Styles.contentContainerLeftFacebookItemAdIndustry}>
                    {this.state.industry}
                </div>
            </div>
        );
    }
}

export default SignupAdsFacebookCanvas;


// WEBPACK FOOTER //
// ./src/components/signup-ads-facebook-canvas/component.js